import { Link } from "@/src/i18n/navigation";
import { useLocale } from "next-intl";
import Image from "next/image";

export interface HighlightProps {
  thumbnail: string;
  label: { text: string }[];
  watermark: string;
  description: string;
}

export default function Highlight(props: HighlightProps) {
  const lang = useLocale();

  return (
    <section className="location-image bg-coffebrown">
      <div className="xl:max-w-screen-xl xl:mx-auto xl:pt-28 pb-10 xl:pb-20">
        <div
          className="relative bg-cover xl:rounded-[45px]"
          style={{
            backgroundImage: `url(${props.thumbnail})`,
            aspectRatio: "1440/860",
          }}
        >
          <Link
            locale={lang}
            href={"/serenity-tower"}
            className="flex absolute items-center justify-center
            top-[26%] xl:top-[29.5%] left-[38%]
             w-[8.9%] h-[5.5%]"
          >
            <div className="flex items-center flex-col">
              <div className="text-center">
                <p className="font-medium font-pluto leading-2 xl:leading-6 text-white text-center text-shadow text-[10px] xl:text-2xl">
                  {props.label[0].text}
                </p>
                <span className="text-white text-center text-shadow text-[10px] xl:text-base font-medium">
                  TOWER
                </span>
              </div>

              <Image
                src="/chevron-down-white.svg"
                alt="arrow down"
                width={24}
                height={24}
                className="mx-auto -mt-1.5 w-3 h-3 xl:w-6 xl:h-6"
              />
            </div>
          </Link>

          <Link
            locale={lang}
            href={"/harmony-tower"}
            className="flex absolute items-center justify-center
             top-[17%] xl:top-[19%] left-[49.5%]
             w-[8.9%] h-[5.5%]"
          >
            <div className="flex items-center flex-col">
              <div className="text-center">
                <p className="font-medium font-pluto leading-2 xl:leading-6 text-white text-center text-shadow text-[10px] xl:text-2xl">
                  {props.label[1].text}
                </p>
                <span className="text-white text-center text-shadow text-[10px] xl:text-base font-medium">
                  TOWER
                </span>
              </div>

              <Image
                src="/chevron-down-white.svg"
                alt="arrow down"
                width={24}
                height={24}
                className="mx-auto w-3 h-3 xl:w-6 xl:h-6 -mt-1.5"
              />
            </div>
          </Link>
        </div>
      </div>

      <p
        className="text-white text-center font-karbon text-[13px] xl:text-3xl mx-9 xl:mx-0 xl:leading-12"
        dangerouslySetInnerHTML={{ __html: props.description }}
      ></p>
    </section>
  );
}
